import { useQuery } from '@tanstack/react-query';
import { FeaturesApi } from '@digiwedge/access-control-api-client';
import { createAccessControlConfiguration, createAccessControlQueryScope, useAccessControlContext, } from './AccessControlApiProvider.js';
export function useFeaturesQueryControllerGetAllFeaturesQuery(args, options) {
    const accessControlContext = useAccessControlContext();
    const accessControlScope = createAccessControlQueryScope(accessControlContext);
    const accessControlConfig = createAccessControlConfiguration(accessControlContext);
    return useQuery({
        queryKey: ['featuresQueryControllerGetAllFeatures', accessControlScope, args],
        queryFn: async () => {
            const api = new FeaturesApi(accessControlConfig);
            return api.featuresQueryControllerGetAllFeatures(...args);
        },
        ...options,
    });
}
//# sourceMappingURL=useFeaturesQueryControllerGetAllFeaturesQuery.js.map